import React, { useEffect } from "react";
import { Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import AlertBox from "../../../components/common/AlertBox";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getDistributorRetailerWiseReportReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearDistributorRetailerWiseReportList } from "../reportsSlice";
import {
  calculateTotalRow,
  createChunks,
  formatIndianNumber,
  getUnitTypes,
  reconstructData,
} from "../../../_helper/helper";
import { sumBy } from "lodash";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const DistributorRetailerWiseReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("distributorRetailerreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const DistributorRetailerWiseReportList = useAppSelector(
    (state) => state.reports.DistributorRetailerWiseReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
      distributor_id: state?.distributor_id,
      item_group_id: state?.item_group_id,
    };
    const res = await dispatch(getDistributorRetailerWiseReportReport(payload));
    if (res.meta.requestStatus === "fulfilled") {
      setPrintStyles();
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("distributorRetailerreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearDistributorRetailerWiseReportList());
    };
  }, []);

  // This function retrun me which item have how many unit type
  const unitArray = getUnitTypes(DistributorRetailerWiseReportList);

  // This function create chunk of checking unittype
  const distributorChunks = createChunks(unitArray);

  // This funtion return tables accouding distributorChunks
  const DistributorRetailerWiseList = distributorChunks.map((item: any) => {
    return reconstructData(item, DistributorRetailerWiseReportList);
  });

  const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
    return formRenderProps.valueGetter("filter_columns")?.includes(key);
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {DistributorRetailerWiseReportList &&
      DistributorRetailerWiseReportList.length ? (
        <Form
          initialValues={initialValues}
          render={(formRenderProps: FormRenderProps) => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <ButtonWithLoading
                    buttonStyle={{
                      position: "fixed",
                      right: 20,
                      top: 20,
                      zIndex: 100,
                    }}
                    label={"Print"}
                    className="no-visible-print-btn"
                    type="button"
                    onClick={() => window.print()}
                  />
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h5 className="m-0 text-center w-100">
                      Retailer Wise Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          <>
                            For Distributor -
                            <span style={{ color: "red" }}>
                              {`${
                                state.distributor_id
                                  ? `${state.distributor?.account_name} `
                                  : ""
                              } -`}
                            </span>
                          </>
                          {state.from_date &&
                            state.to_date &&
                            `( ${moment(state.from_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} )`}
                        </p>
                      </>
                    </Typography.h5>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {DistributorRetailerWiseList?.map(
                      (salesmanlist: any, index: number) => {
                        const unitArrayType = salesmanlist?.[0].unitTypes?.[0];
                        const isprintTotalCol =
                          unitArrayType.length === 1 &&
                          unitArrayType[0].unitTypes.length <= 2;
                        return (
                          <table
                            cellSpacing={1}
                            cellPadding={2}
                            className={`table table-bordered salesmanwisereport-print ${
                              index > 0 ? "salesmanwisereport-print-break" : ""
                            }`}
                            style={{
                              width: "fit-content",
                            }}
                          >
                            <thead>
                              <tr
                                className="text-center fw-600"
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                <>
                                  <th style={{ minWidth: 50 }} rowSpan={2}>
                                    Order No.
                                  </th>
                                </>

                                {checkInclude(
                                  "distributor_name",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 160 }} rowSpan={2}>
                                      Distributor Name
                                    </th>
                                  </>
                                )}
                                {checkInclude(
                                  "retailer_name",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 160 }} rowSpan={2}>
                                      Retailer Name
                                    </th>
                                  </>
                                )}
                                {checkInclude("date_time", formRenderProps) && (
                                  <>
                                    <th style={{ minWidth: 100 }} rowSpan={2}>
                                      Date Time
                                    </th>
                                  </>
                                )}
                                {checkInclude("item_group", formRenderProps) &&
                                  unitArrayType?.map(
                                    (item_group: any, index: any) => (
                                      <th
                                        key={index}
                                        colSpan={
                                          2 * item_group.unitTypes?.length + 1
                                        }
                                      >
                                        {item_group.item_group?.toUpperCase()}{" "}
                                        GROUP
                                      </th>
                                    )
                                  )}
                                {isprintTotalCol && (
                                  <>
                                    {checkInclude(
                                      "total_kg_qty",
                                      formRenderProps
                                    ) && (
                                      <>
                                        <th
                                          style={{ minWidth: 150 }}
                                          rowSpan={2}
                                        >
                                          Total KG
                                        </th>
                                      </>
                                    )}
                                    {checkInclude(
                                      "total_pkt_qty",
                                      formRenderProps
                                    ) && (
                                      <>
                                        <th
                                          style={{ minWidth: 150 }}
                                          rowSpan={2}
                                        >
                                          Total PACKET
                                        </th>
                                      </>
                                    )}
                                    {checkInclude(
                                      "total_bdh_qty",
                                      formRenderProps
                                    ) && (
                                      <>
                                        <th
                                          style={{ minWidth: 150 }}
                                          rowSpan={2}
                                        >
                                          Total BANDHA
                                        </th>
                                      </>
                                    )}
                                    {checkInclude(
                                      "ground_total",
                                      formRenderProps
                                    ) && (
                                      <>
                                        <th
                                          style={{ minWidth: 150 }}
                                          rowSpan={2}
                                        >
                                          Grand Total
                                        </th>
                                      </>
                                    )}
                                  </>
                                )}
                              </tr>

                              <tr
                                className="text-center fw-600"
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                {/* Dynamically Generate Unit and Value Headers */}
                                {checkInclude("item_group", formRenderProps) &&
                                  unitArrayType.map(
                                    (group: any, groupIndex: number) => (
                                      <React.Fragment key={groupIndex}>
                                        {group?.unitTypes?.map(
                                          (unit: string, unitIdx: number) => (
                                            <React.Fragment key={unitIdx}>
                                              <th style={{ minWidth: 100 }}>
                                                {unit}
                                              </th>
                                              <th style={{ minWidth: 100 }}>
                                                Value
                                              </th>
                                            </React.Fragment>
                                          )
                                        )}
                                        <th style={{ minWidth: 100 }}>Total</th>
                                      </React.Fragment>
                                    )
                                  )}
                              </tr>
                            </thead>

                            {/* Table Body */}

                            <tbody>
                              {salesmanlist.map(
                                (item: any, rowIndex: number) => {
                                  const totalItemGroups = Array.from(
                                    new Set(
                                      salesmanlist.flatMap((entry: any) =>
                                        entry.item_groups.map(
                                          (group: any) => group.item_group
                                        )
                                      )
                                    )
                                  );

                                  return (
                                    <>
                                      <tr key={rowIndex}>
                                        {/* <td>{rowIndex + 1}</td> */}
                                        <td>{item?.retailer_sales_order_no}</td>
                                        {checkInclude(
                                          "distributor_name",
                                          formRenderProps
                                        ) && <td>{item.distributor_name}</td>}
                                        {checkInclude(
                                          "retailer_name",
                                          formRenderProps
                                        ) && <td>{item.retailer_name}</td>}
                                        {checkInclude(
                                          "date_time",
                                          formRenderProps
                                        ) && (
                                          <td>
                                            {item.date_time
                                              ? moment(
                                                  item.date_time,
                                                  "DD/MM/YYYY HH:mm:ss"
                                                ).format("DD-MMM-YYYY hh:mm A")
                                              : ""}
                                          </td>
                                        )}
                                        {checkInclude(
                                          "item_group",
                                          formRenderProps
                                        ) &&
                                          totalItemGroups.map((_, index) => {
                                            const groupData = item?.item_groups
                                              ?.filter(
                                                (item: any) =>
                                                  item.item_data?.length > 0
                                              )
                                              ?.find(
                                                (group: any) =>
                                                  group.item_group ===
                                                  totalItemGroups[index]
                                              );
                                            const units =
                                              unitArrayType[index].unitTypes ||
                                              [];

                                            return (
                                              <>
                                                {units.map((unit: string) => {
                                                  const qtyKey =
                                                    unit === "KG"
                                                      ? "unit_kg_qty"
                                                      : unit === "PACKET"
                                                      ? "unit_pkt_qty"
                                                      : "unit_bdh_qty";
                                                  const amtKey =
                                                    unit === "KG"
                                                      ? "unit_kg_amt"
                                                      : unit === "PACKET"
                                                      ? "unit_pkt_amt"
                                                      : "unit_bdh_amt";

                                                  return (
                                                    <React.Fragment key={unit}>
                                                      <td
                                                        style={{
                                                          textAlign: "end",
                                                        }}
                                                      >
                                                        {groupData
                                                          ?.item_data[0][qtyKey]
                                                          ? groupData?.item_data[0][
                                                              qtyKey
                                                            ]?.toFixed(2)
                                                          : 0}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "end",
                                                        }}
                                                      >
                                                        {groupData
                                                          ?.item_data[0][amtKey]
                                                          ? groupData?.item_data[0][
                                                              amtKey
                                                            ]?.toFixed(2)
                                                          : 0}
                                                      </td>
                                                    </React.Fragment>
                                                  );
                                                })}

                                                <td
                                                  style={{ textAlign: "end" }}
                                                >
                                                  {units
                                                    .reduce(
                                                      (
                                                        total: number,
                                                        unit: string
                                                      ) => {
                                                        const amtKey =
                                                          unit === "KG"
                                                            ? "unit_kg_amt"
                                                            : unit === "PACKET"
                                                            ? "unit_pkt_amt"
                                                            : "unit_bdh_amt";
                                                        return (
                                                          total +
                                                          (groupData
                                                            ?.item_data[0][
                                                            amtKey
                                                          ] || 0)
                                                        );
                                                      },
                                                      0
                                                    )
                                                    .toFixed(2)}
                                                </td>
                                              </>
                                            );
                                          })}
                                        {isprintTotalCol && (
                                          <>
                                            {checkInclude(
                                              "total_kg_qty",
                                              formRenderProps
                                            ) && (
                                              <td className="text-end">
                                                {item.total_kg_qty?.toFixed(2)}
                                              </td>
                                            )}
                                            {checkInclude(
                                              "total_pkt_qty",
                                              formRenderProps
                                            ) && (
                                              <td className="text-end">
                                                {item.total_pkt_qty?.toFixed(2)}
                                              </td>
                                            )}
                                            {checkInclude(
                                              "total_bdh_qty",
                                              formRenderProps
                                            ) && (
                                              <td className="text-end">
                                                {item.total_bdh_qty?.toFixed(2)}
                                              </td>
                                            )}
                                            {checkInclude(
                                              "ground_total",
                                              formRenderProps
                                            ) && (
                                              <td className="text-end">
                                                {formatIndianNumber(
                                                  item.ground_total
                                                )}
                                              </td>
                                            )}
                                          </>
                                        )}
                                      </tr>
                                    </>
                                  );
                                }
                              )}
                            </tbody>
                            <tfoot>
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "lightgrey",
                                }}
                              >
                                <td
                                  colSpan={
                                    checkInclude(
                                      "distributor_name",
                                      formRenderProps
                                    )
                                      ? 3
                                      : 2
                                  }
                                  style={{ fontWeight: "bold" }}
                                >
                                  Final Total
                                </td>
                                {checkInclude(
                                  "retailer_name",
                                  formRenderProps
                                ) && <td style={{ fontWeight: "bold" }}></td>}

                                {checkInclude("item_group", formRenderProps) &&
                                  Array.from(
                                    new Set(
                                      salesmanlist.flatMap((entry: any) =>
                                        entry.item_groups.map(
                                          (group: any) => group.item_group
                                        )
                                      )
                                    )
                                  ).map((_, index) => {
                                    const groupTotal = calculateTotalRow(
                                      Array.from(
                                        new Set(
                                          salesmanlist.flatMap((entry: any) =>
                                            entry.item_groups.map(
                                              (group: any) => group.item_group
                                            )
                                          )
                                        )
                                      ),
                                      salesmanlist
                                    ).item_group[index];

                                    return (
                                      <>
                                        {unitArrayType[index].unitTypes.map(
                                          (unit: string, unitindex: number) => (
                                            <>
                                              <td
                                                key={`${unit}-total-${
                                                  unitindex + 1
                                                }`}
                                                style={{ textAlign: "end" }}
                                              >
                                                {groupTotal.qty[unit]?.toFixed(
                                                  2
                                                )}{" "}
                                              </td>
                                              <td
                                                key={`${unit}-total-${
                                                  unitindex + 2
                                                }`}
                                                style={{ textAlign: "end" }}
                                              >
                                                {groupTotal.amt[unit]?.toFixed(
                                                  2
                                                )}
                                              </td>
                                            </>
                                          )
                                        )}
                                        <td style={{ textAlign: "end" }}>
                                          {(
                                            groupTotal.amt.KG +
                                            groupTotal.amt.PACKET +
                                            groupTotal.amt.BANDHA
                                          )?.toFixed(2)}
                                        </td>
                                      </>
                                    );
                                  })}
                                {isprintTotalCol && (
                                  <>
                                    {checkInclude(
                                      "total_kg_qty",
                                      formRenderProps
                                    ) && (
                                      <td
                                        style={{ fontWeight: "bold" }}
                                        className="text-end"
                                      >
                                        {sumBy(
                                          DistributorRetailerWiseList[0],
                                          "total_kg_qty"
                                        )?.toFixed(2)}
                                      </td>
                                    )}
                                    {checkInclude(
                                      "total_pkt_qty",
                                      formRenderProps
                                    ) && (
                                      <td
                                        style={{ fontWeight: "bold" }}
                                        className="text-end"
                                      >
                                        {sumBy(
                                          DistributorRetailerWiseList[0],
                                          "total_pkt_qty"
                                        )?.toFixed(2)}
                                      </td>
                                    )}
                                    {checkInclude(
                                      "total_bdh_qty",
                                      formRenderProps
                                    ) && (
                                      <td
                                        style={{ fontWeight: "bold" }}
                                        className="text-end"
                                      >
                                        {sumBy(
                                          DistributorRetailerWiseList[0],
                                          "total_bdh_qty"
                                        )?.toFixed(2)}
                                      </td>
                                    )}
                                    {checkInclude(
                                      "ground_total",
                                      formRenderProps
                                    ) && (
                                      <td
                                        style={{ fontWeight: "bold" }}
                                        className="text-end"
                                      >
                                        {formatIndianNumber(
                                          sumBy(
                                            DistributorRetailerWiseList[0],
                                            "ground_total"
                                          )
                                        )}
                                      </td>
                                    )}
                                  </>
                                )}
                              </tr>
                            </tfoot>
                          </table>
                        );
                      }
                    )}
                    {DistributorRetailerWiseList?.map(
                      (salesmanlist: any, index: number) => {
                        const unitArrayType = salesmanlist?.[0].unitTypes?.[0];
                        const isprintTotalCol =
                          unitArrayType.length === 1 &&
                          unitArrayType[0].unitTypes.length <= 2;
                        if (index !== DistributorRetailerWiseList.length - 1)
                          return;
                        if (isprintTotalCol) return;

                        return (
                          <table
                            cellSpacing={1}
                            cellPadding={2}
                            className={`table table-bordered salesmanwisereport-print salesmanwisereport-print-break
                                                                                        `}
                            style={{
                              width: "fit-content",
                            }}
                          >
                            <thead>
                              <tr
                                className="text-center fw-600"
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                <>
                                  <th style={{ minWidth: 50 }} rowSpan={2}>
                                    Order No.
                                  </th>
                                </>

                                {checkInclude(
                                  "distributor_name",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 160 }} rowSpan={2}>
                                      Distributor Name
                                    </th>
                                  </>
                                )}
                                {checkInclude(
                                  "retailer_name",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 160 }} rowSpan={2}>
                                      Retailer Name
                                    </th>
                                  </>
                                )}
                                {checkInclude("date_time", formRenderProps) && (
                                  <>
                                    <th style={{ minWidth: 100 }} rowSpan={2}>
                                      Date Time
                                    </th>
                                  </>
                                )}

                                {checkInclude(
                                  "total_kg_qty",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 150 }}>Total KG</th>
                                  </>
                                )}
                                {checkInclude(
                                  "total_pkt_qty",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 150 }}>
                                      Total PACKET
                                    </th>
                                  </>
                                )}
                                {checkInclude(
                                  "total_bdh_qty",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 150 }}>
                                      Total BANDHA
                                    </th>
                                  </>
                                )}
                                {checkInclude(
                                  "ground_total",
                                  formRenderProps
                                ) && (
                                  <>
                                    <th style={{ minWidth: 150 }}>
                                      Grand Total
                                    </th>
                                  </>
                                )}
                              </tr>
                            </thead>

                            {/* Table Body */}
                            <tbody>
                              {salesmanlist.map(
                                (item: any, rowIndex: number) => {
                                  return (
                                    <React.Fragment key={rowIndex + 124}>
                                      <tr>
                                        {/* <td>{rowIndex + 1}</td> */}
                                        <td>{item?.retailer_sales_order_no}</td>
                                        {checkInclude(
                                          "distributor_name",
                                          formRenderProps
                                        ) && (
                                          <td style={{ minWidth: 160 }}>
                                            {item?.distributor_name}
                                          </td>
                                        )}
                                        {checkInclude(
                                          "retailer_name",
                                          formRenderProps
                                        ) && <td>{item?.retailer_name}</td>}
                                        {checkInclude(
                                          "date_time",
                                          formRenderProps
                                        ) && (
                                          <td>
                                            {item.date_time
                                              ? moment(
                                                  item.date_time,
                                                  "DD/MM/YYYY HH:mm:ss"
                                                ).format("DD-MMM-YYYY hh:mm A")
                                              : ""}
                                          </td>
                                        )}

                                        {checkInclude(
                                          "total_kg_qty",
                                          formRenderProps
                                        ) && (
                                          <td className="text-end">
                                            {item.total_kg_qty?.toFixed(2)}
                                          </td>
                                        )}
                                        {checkInclude(
                                          "total_pkt_qty",
                                          formRenderProps
                                        ) && (
                                          <td className="text-end">
                                            {item.total_pkt_qty?.toFixed(2)}
                                          </td>
                                        )}
                                        {checkInclude(
                                          "total_bdh_qty",
                                          formRenderProps
                                        ) && (
                                          <td className="text-end">
                                            {item.total_bdh_qty?.toFixed(2)}
                                          </td>
                                        )}
                                        {checkInclude(
                                          "ground_total",
                                          formRenderProps
                                        ) && (
                                          <td className="text-end">
                                            {formatIndianNumber(
                                              item.ground_total
                                            )}
                                          </td>
                                        )}
                                      </tr>
                                    </React.Fragment>
                                  );
                                }
                              )}

                              {/* TOTAL ROW */}
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "lightgrey",
                                }}
                              >
                                <td colSpan={2} style={{ fontWeight: "bold" }}>
                                  Final Total
                                </td>
                                {checkInclude(
                                  "distributor_name",
                                  formRenderProps
                                ) && <td style={{ fontWeight: "bold" }}></td>}
                                {checkInclude(
                                  "retailer_name",
                                  formRenderProps
                                ) && <td style={{ fontWeight: "bold" }}></td>}

                                {checkInclude(
                                  "total_kg_qty",
                                  formRenderProps
                                ) && (
                                  <td
                                    style={{ fontWeight: "bold" }}
                                    className="text-end"
                                  >
                                    {sumBy(
                                      DistributorRetailerWiseList[0],
                                      "total_kg_qty"
                                    )?.toFixed(2)}
                                  </td>
                                )}
                                {checkInclude(
                                  "total_pkt_qty",
                                  formRenderProps
                                ) && (
                                  <td
                                    style={{ fontWeight: "bold" }}
                                    className="text-end"
                                  >
                                    {sumBy(
                                      DistributorRetailerWiseList[0],
                                      "total_pkt_qty"
                                    )?.toFixed(2)}
                                  </td>
                                )}
                                {checkInclude(
                                  "total_bdh_qty",
                                  formRenderProps
                                ) && (
                                  <td
                                    style={{ fontWeight: "bold" }}
                                    className="text-end"
                                  >
                                    {sumBy(
                                      DistributorRetailerWiseList[0],
                                      "total_bdh_qty"
                                    )?.toFixed(2)}
                                  </td>
                                )}
                                {checkInclude(
                                  "ground_total",
                                  formRenderProps
                                ) && (
                                  <td
                                    style={{ fontWeight: "bold" }}
                                    className="text-end"
                                  >
                                    {formatIndianNumber(
                                      sumBy(
                                        DistributorRetailerWiseList[0],
                                        "ground_total"
                                      )
                                    )}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        );
                      }
                    )}
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default DistributorRetailerWiseReport;
